
function camelToTitleCase(str: string): string {
    return str
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (c) => c.toUpperCase())
        .trim();
}

export function formatFieldPath(fieldPath: string): string {
    if (fieldPath === "") {
        return "";
    }
    const segments = fieldPath
        .split(".")
        .map((segment) =>
            /^\d+$/.test(segment) ? String(Number(segment) + 1) : camelToTitleCase(segment)
        );

    const lines: string[] = [];
    for (let i = 0; i < segments.length; i += 2) {
        lines.push(segments.slice(i, i + 2).join(" "));
    }
    return lines.join("\n");
}

const SOURCE_MAP: Record<string, string> = {
    ham: "HAM",
    amznham: "Shop",
};

export function formatSource(source: string): string {
    if (source === "") {
        return "";
    }
    return SOURCE_MAP[source] ?? source;
}

export function formatValue(value: string): string {
    if (value === "") {
        return "";
    }
    if (value.startsWith("{") || value.startsWith("[")) {
        try {
            const parsed = JSON.parse(value);
            return JSON.stringify(parsed, null, 2);
        } catch {
            return value;
        }
    }
    return value;
}
